import _ from 'underscore';

var extract = function(context, key, def, init, data) {
	var k = key.shift(),
		value;

	if (_.isUndefined(context[k]) && init) {
		if (key.length > 0) {
			context[k] = {};
		} else if (key.length === 0) {
			context[k] = def;
		}
	}
	context = context[k];
	if (_.isUndefined(context) || key.length === 0) {
		return _.isFunction(context) ? context(data) : (context || def);
	} else {
		return extract(context, key, def, init, data);
	}
}

_.mixin({
	extract: function(context, key, def, init, data) {
		if (_.isUndefined(context)) {
			return def;
		}
		if (_.isString(context)) {
            data = init;
			init = def;
			def = key;
			key = context;
			context = window;
		}
		if (_.isString(key) && key.length>0) {
			key = key.split('.');
			return extract(context, key, def, init, data);
		} else {
			return context;
		}
	}
});

export default _;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/underscore_extend.js